import { MessageFormatElement } from '@formatjs/icu-messageformat-parser/types';
import React, { useState, useMemo } from 'react';
import ReactGA from 'react-ga4';
import { IntlProvider } from 'react-intl';
import { BrowserRouter } from 'react-router-dom';

import './assets/less/App.less';
import './assets/css/style.css';

import { ApiProvider } from './apiClient/ApiContext';
import NotificationPanel from './components/notifications/NotificationPanel';
import PopupNotification from './components/PopupNotification/PopupNotification';
import LocaleContext from './contexts/LocaleContext';
import NotificationProvider from './contexts/Notifications/NotificationProvider';

import messagesCS from './lang/cs.json';
import messagesUA from './lang/ua.json';
import AppRoutes from './routes';
import { TyToastContainer } from '@tymbe/ty-components/indicators';

ReactGA.initialize('G-J6CPRWKJTG', {
  // Uncomment to enable debug mode
  gaOptions: {
    debug_mode: ['development', 'stage'].includes(import.meta.env.NODE_ENV) || import.meta.env.DEV,
  },
  gtagOptions: {
    debug_mode: ['development', 'stage'].includes(import.meta.env.NODE_ENV) || import.meta.env.DEV,
  },
});
interface RootProps {
  authenticated: boolean;
  locale: string;
  messages: Record<string, MessageFormatElement[]> | null;
}

const App: React.FC<RootProps> = () => {
  const [locale, setLocale] = useState('cs');
  const contextValue = useMemo(
    () => ({ locale, setLocale }),
    [locale, setLocale]
  );

  (window as typeof window & { loadFoxentry(key: string): string }).loadFoxentry(import.meta.env.CLIENT_FOXENTRY_ID);

  return (
    <LocaleContext.Provider value={contextValue}>
      <IntlProvider
        locale={locale}
        messages={locale === 'cs' ? messagesCS : messagesUA}
        defaultLocale="cs"
      >
        <NotificationProvider>
          <ApiProvider>
            <BrowserRouter>
              <AppRoutes />
            </BrowserRouter>
            <PopupNotification />
            <NotificationPanel />
            <TyToastContainer />
          </ApiProvider>
        </NotificationProvider>
      </IntlProvider>
    </LocaleContext.Provider>
  );
};

export default App;
